(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.contact-form__input--textarea[data-word-limit]').forEach((textarea) => {
    const limit = parseInt(textarea.dataset.wordLimit, 10) || 200;
    const wrapper = textarea.closest('.contact-form__textarea-wrapper');
    const counter = wrapper ? wrapper.querySelector('.contact-form__word-counter') : null;

    const countWords = (text) => text.trim().split(/\s+/).filter(Boolean);

    const update = () => {
      let words = countWords(textarea.value);

      if (words.length > limit) {
        const caret = textarea.selectionStart;
        textarea.value = words.slice(0, limit).join(' ');
        words = countWords(textarea.value);
        const pos = Math.min(caret, textarea.value.length);
        textarea.setSelectionRange(pos, pos);
      }

      if (counter) {
        counter.textContent = words.length + ' / ' + limit + ' words';
        counter.classList.toggle('contact-form__word-counter--limit', words.length >= limit);
      }
    };

    textarea.addEventListener('input', update);
    textarea.addEventListener('paste', () => setTimeout(update, 0));
    update();
  });
  } catch(e) { console.error(e); }
})();

})();
